import { put, takeLatest } from 'redux-saga/effects';
import { FieldSectionType } from 'api/field-sections/types';
import { TaskAPI } from 'api/tasks';
import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { ACCOUNT_CONFIG_QUERY_KEY } from 'queries/account';
import { getProjectDependencyMapKey, getProjectTasksQueryKey } from 'queries/common';
import { logger } from 'services';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { createSubTaskSagaAction } from '../actions';
import { addSubTaskToTask, createSubTaskSuccess } from '../slice';
function* createSubTaskSaga(action) {
    var _accountConfig_fields, _statusField_metaData;
    const { payload } = action;
    const { projectId, taskId, queryClient, updateLocalState, ...rest } = payload;
    const accountConfig = queryClient.getQueryData(ACCOUNT_CONFIG_QUERY_KEY);
    const statusField = accountConfig === null || accountConfig === void 0 ? void 0 : (_accountConfig_fields = accountConfig.fields) === null || _accountConfig_fields === void 0 ? void 0 : _accountConfig_fields.find((f)=>f.fieldName === STATUS_FIELD_NAME && f.objectType === FieldSectionType.Task);
    if (!statusField) {
        return;
    }
    const { fieldId } = statusField;
    const fieldValue = (_statusField_metaData = statusField.metaData) === null || _statusField_metaData === void 0 ? void 0 : _statusField_metaData.default;
    try {
        yield put(addSubTaskToTask({
            projectId,
            taskId,
            parentTask: rest.parentTask,
            taskName: rest.taskName,
            fields: [
                {
                    fieldId,
                    fieldValue
                }
            ]
        }));
        const task = yield TaskAPI.createTask(projectId, rest);
        // This is done to optimistically update the local state for sub tasks list.
        if (updateLocalState) {
            updateLocalState(task);
        }
        yield put(createSubTaskSuccess({
            projectId,
            parentTask: rest.parentTask,
            taskId,
            task
        }));
        yield invalidateTaskQuery(taskId);
        yield invalidateTaskQuery(rest.parentTask);
        yield queryClient.refetchQueries(getProjectTasksQueryKey([
            'project_id',
            projectId
        ]));
        yield queryClient.refetchQueries(getProjectDependencyMapKey(projectId));
    } catch (error) {
        logger.error('createSubTaskSaga failed', {
            error
        });
    }
}
export function* watchCreateSubTaskSaga() {
    yield takeLatest(createSubTaskSagaAction.type, createSubTaskSaga);
}
